import { useSearchParams } from "react-router-dom";

export const ClientFilterType = {
    Search: 'search',
    Page: 'page',
    PageSize: 'page_size',
} as const;

export type ClientFilterType = typeof ClientFilterType[keyof typeof ClientFilterType];


export default function useGetClientsFiltersQuery() {
    const [searchParams] = useSearchParams();

    const searchQuery = searchParams.get(ClientFilterType.Search);
    const pageQuery = searchParams.get(ClientFilterType.Page);
    const pageSizeQuery = searchParams.get(ClientFilterType.PageSize);




    return {
        pageSizeQuery,
        pageQuery,
        searchQuery,
    };
}
